import { v4 as uuidv4 } from 'uuid';

import { Login } from '../../../../vtex-apps/login/Login/default';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';
import { DrawerCloseButton } from '../../../../vtex-apps/store-drawer/DrawerCloseButton/default';
import { FlexLayoutCol, FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { DrawerHeader } from '../../../../vtex-apps/store-drawer/DrawerHeader/default';
import { Drawer } from '../../../../vtex-apps/store-drawer/Drawer/default';
import { SearchBar } from '../../../../vtex-apps/store-components/SearchBar/default';
import { Logo } from '../../../../vtex-apps/store-components/Logo/default';
import { StickyLayout } from '../../../../vtex-apps/sticky-layout/StickyLayout/default';
import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';
import { Image } from '../../../../vtex-apps/store-components/Image/default';
import { SliderLayout } from '../../../../vtex-apps/slider-layout/SliderLayout/default';

const HeaderMobile = () => {
	return {
		componentName: 'HeaderMobile',
		componentId: uuidv4(),
		componentGroup: 'HeaderMobile',
		variables,
		props: {
			mzTitle: 'MZ | Header - Mobile',
		},
		childrenComponents: [
			VisibilityLayout({ mzTitle: 'MZ | Topbar (On/Off)' }, [
				FlexLayoutRow(
					{
						mzTitle: 'MZ | Topbar',
						blockClass: 'mz-header-1-mobile__topbar-row',
						preserveLayoutOnMobile: true,
						paddingTop: 2,
						paddingBottom: 2,
					},
					[
						SliderLayout(
							{
								blockClass: 'mz-header-1-mobile__topbar-slider',
								showNavigationArrows: 'never',
								showPaginationDots: 'never',
								autoplay: {
									timeout: 5000,
								},
								arrowSize: 14,
							},
							[
								VisibilityLayout({ mzTitle: 'MZ | Slide 1 (On/Off)' }, [
									FlexLayoutRow({ blockClass: 'mz-header-1-mobile__slider-row', preserveLayoutOnMobile: true }, [
										Image({
											blockClass: 'mz-header-1-mobile__topbar-image',
											src: 'https://hefesto-upload-images.s3.amazonaws.com/1682365252437-1682365097262-mz-icon-pix---37417b16296b4eb32c640ad03719aa1f.png',
										}),
										RichText({
											text: 'Entrega em todo o Brasil',
											blockClass: 'mz-header-1-mobile__topbar-slider-text',
										}),
									]),
								]),
								VisibilityLayout({ mzTitle: 'MZ | Slide 2 (On/Off)' }, [
									FlexLayoutRow({ blockClass: 'mz-header-1-mobile__slider-row', preserveLayoutOnMobile: true }, [
										Image({
											blockClass: 'mz-header-1-mobile__topbar-image',
											src: 'https://hefesto-upload-images.s3.amazonaws.com/1682365252437-1682365097262-mz-icon-pix---37417b16296b4eb32c640ad03719aa1f.png',
										}),
										RichText({
											text: 'Entrega em todo o Brasil',
											blockClass: 'mz-header-1-mobile__topbar-slider-text',
										}),
									]),
								]),
								VisibilityLayout({ mzTitle: 'MZ | Slide 3 (On/Off)' }, [
									FlexLayoutRow({ blockClass: 'mz-header-1-mobile__slider-row', preserveLayoutOnMobile: true }, [
										Image({
											blockClass: 'mz-header-1-mobile__topbar-image',
											src: 'https://hefesto-upload-images.s3.amazonaws.com/1682365252437-1682365097262-mz-icon-pix---37417b16296b4eb32c640ad03719aa1f.png',
										}),
										RichText({
											text: 'Entrega em todo o Brasil',
											blockClass: 'mz-header-1-mobile__topbar-slider-text',
										}),
									]),
								]),
								VisibilityLayout({ mzTitle: 'MZ | Slide 4 (On/Off)' }, [
									FlexLayoutRow({ blockClass: 'mz-header-1-mobile__slider-row', preserveLayoutOnMobile: true }, [
										Image({
											blockClass: 'mz-header-1-mobile__topbar-image',
											src: 'https://hefesto-upload-images.s3.amazonaws.com/1682365252437-1682365097262-mz-icon-pix---37417b16296b4eb32c640ad03719aa1f.png',
										}),
										RichText({
											text: 'Entrega em todo o Brasil',
											blockClass: 'mz-header-1-mobile__topbar-slider-text',
										}),
									]),
								]),
								VisibilityLayout({ mzTitle: 'MZ | Slide 5 (On/Off)' }, [
									FlexLayoutRow({ blockClass: 'mz-header-1-mobile__slider-row', preserveLayoutOnMobile: true }, [
										Image({
											blockClass: 'mz-header-1-mobile__topbar-image',
											src: 'https://hefesto-upload-images.s3.amazonaws.com/1682365252437-1682365097262-mz-icon-pix---37417b16296b4eb32c640ad03719aa1f.png',
										}),
										RichText({
											text: 'Entrega em todo o Brasil',
											blockClass: 'mz-header-1-mobile__topbar-slider-text',
										}),
									]),
								]),
							],
						),
					],
				),
			]),
			StickyLayout({ blockClass: 'header-1-mobile', position: 'top', verticalSpacing: 0 }, [
				FlexLayoutRow({ colSizing: 'auto', blockClass: 'mz-header-1-mobile', fullWidth: true }, [
					Drawer(
						{ blockClass: 'mz-header-1-mobile', slideDirection: 'horizontal', isFullWidth: true },
						[
							DrawerHeader({ blockClass: 'mz-header-1-mobile' }, [
								DrawerCloseButton({ blockClass: 'mz-header-1-mobile' }),
							]),
						],
						[
							FlexLayoutRow(
								{
									colSizing: 'auto',
									blockClass: 'mz-header-1-mobile__login-container',
									preserveLayoutOnMobile: true,
									horizontalAlign: 'between',
								},
								[
									FlexLayoutCol({ blockClass: 'mz-header-1-mobile__login' }, [
										Login({
											iconLabel: 'Minha conta',
											blockClass: 'mz-header-1-mobile__login-text',
											accountOptionsButtonBehavior: 'link',
										}),
									]),
									FlexLayoutCol({ blockClass: 'mz-header-1-mobile__favoritos' }, [
										RichText({
											text: 'Meus **favoritos**',
											blockClass: 'mz-header-1-mobile__favoritos-text',
										}),
									]),
								],
							),
							{
								componentGroup: 'StoreMenuMobile',
								componentName: 'Menu',
								componentId: uuidv4(),
							},
						],
					),
					Logo({
						height: 30,
						title: 'Logo',
						blockClass: 'mz-header-1-mobile',
						url: 'https://maeztra.com/wp-content/uploads/2020/09/logo_Prancheta-1.svg',
					}),

					FlexLayoutRow({ blockClass: 'mz-header-1-mobile-icons' }, [
						Login({
							iconLabel: 'Minha Conta',
							blockClass: 'mz-header-1-mobile',
						}),
						RichText({
							text: 'Meus Pedidos',
							blockClass: 'mz-header-1-mobile',
						}),
						{
							componentGroup: 'MinicartGroup',
							componentName: 'MinicartGroup',
							componentId: uuidv4(),
						},
					]),
				]),
				FlexLayoutRow({ blockClass: 'mz-header-1-mobile', fullWidth: true, colSizing: 'equal' }, [
					SearchBar({ placeholder: 'O que você procura?', width: '100%', blockClass: 'mz-header-1-mobile' }),
				]),
			]),
			// VisibilityLayout({ visible: true, mzTitle: "Modal de cookies" }, [{ componentName: "CookieModal" }]),
			VisibilityLayout({ mzTitle: 'MZ | Botão Whatsapp (On/Off)' }, [
				FlexLayoutRow({ blockClass: 'mz-header-mob-1-whats-float__flex-row', preserveLayoutOnMobile: true }, [
					Image({
						blockClass: 'whatsapp-float-mob-1__image',
						src: 'https://hefesto-upload-images.s3.amazonaws.com/1682006713447-1681501967650-WhatsApp.png',
					}),
					RichText({ blockClass: 'whatsapp-float-mob-1__text', text: '[Atendimento](https://whts.co/)' }),
				]),
			]),
		],
	};
};

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--white', to: '--header-mobile-1-bg-color', name: 'Header Background' },
			{ from: '--white', to: '--header-mobile-1-menu-bg-color', name: 'Menu Background' },
			{ from: '--white', to: '--header-mobile-1-dr-head-bg-color', name: 'Drawer Header' },
			{ from: '--text-color-1', to: '--header-mobile-1-dr-head-text-color', name: 'Drawer Header Text' },
			{ from: '--text-color-1-dark', to: '--header-mobile-1-text-color', name: 'Icons' },
			{ from: '--text-color-1-dark', to: '--header-mobile-1-search-border-color', name: 'Search Border' },
			{ from: '--text-color-1-dark', to: '--header-mobile-1-search-button-color', name: 'Search Button' },
			{ from: '--white', to: '--header-mobile-1-search-button-icon', name: 'Search Button Icon' },
			//minicart color
			{ from: '--support-color-3', to: '--header-mobile-1-minicart-color', name: 'Minicart' },
			{ from: '--white', to: '--header-mobile-1-minicart-text', name: 'Minicart Text' },
			{ from: '--support-color-3', to: '--header-mobile-1-whatsapp-bg-color', name: 'Whatsapp Background' },
			{ from: '--support-color-3', to: '--header-mobile-1-whatsapp-bg-hover', name: 'Whatsapp Background Hover' },
			//search autocomplete
			{
				from: '--neutral-color-low-medium',
				to: '--header-mobile-1-search-autocomplete-text-color',
				name: 'Search Autocomplete Text',
			},
			//--header-mobile-1-topbar-bg-color
			{ from: '--support-color-3', to: '--header-mobile-1-topbar-bg-color', name: 'Topbar Background' },
			//--header-mobile-1-topbar-color
			{ from: '--white', to: '--header-mobile-1-topbar-color', name: 'Topbar Text' },
			//--mz-header-1-mobile-topbar-slider-arrow-color
			{ from: '--white', to: '--header-mobile-1-topbar-slider-arrow-color', name: 'Topbar Slider Arrow' },
		],
	},
	{
		type: 'borderRadius',
		list: [
			{ from: '--border-radius-none', to: '--header-mobile-1-border-radius', name: 'Border Radius' },
			//whatsapp border radius
			{ from: '--border-radius-sm', to: '--header-mobile-1-whatsapp-br', name: 'Whatsapp' },
			//search autocomplete
			{ from: '--border-radius-sm', to: '--header-mobile-1-search-autocomplete-br', name: 'Search Autocomplete' },
		],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-sm', to: '--header-mobile-1-main-size', name: 'Main Font Size' },
			//search autocomplete
			{ from: '--font-size-xs', to: '--header-mobile-1-search-autocomplete-fs', name: 'Search Autocomplete' },
			//--header-mobile-1-topbar-fs
			{ from: '--font-size-xs', to: '--header-mobile-1-topbar-fs', name: 'Topbar' },
		],
	},
	//typography
	{
		type: 'typography',
		list: [
			//--header-mobile-1-topbar-ff
			{ from: '--main-font', to: '--header-mobile-1-topbar-ff', name: 'Topbar' },
		],
	},
];

export default HeaderMobile;
